module.exports = __webpack_public_path__ + "static/media/fsc5.0c2f49d6.svg";